export type RoutePageData = {
  slug: string;
  originId: string;
  destinationId: string;
  pickupValue: string;
  destinationValue: string;
  price4: number;
  price8: number;
  distance: string;
  duration: string;
  routeType: "airport" | "private" | "long-distance";
};

export const routePages: Record<string, RoutePageData> = {
 "faro-airport-to-albufeira": {
    slug: "faro-airport-to-albufeira",
    originId: "faro-airport",
    destinationId: "albufeira",
pickupValue: "faro",
    destinationValue: "Albufeira",
    price4: 45,
    price8: 55,
    distance: "45 km",
    duration: "30 min",
    routeType: "airport",
  },

  "faro-airport-to-vilamoura": {
    slug: "faro-airport-to-vilamoura",
    originId: "faro-airport",
    destinationId: "vilamoura",
    pickupValue: "faro",
    destinationValue: "Vilamoura",
    price4: 35,
    price8: 45,
    distance: "25 km",
    duration: "25 min",
    routeType: "airport",
  },

  "faro-airport-to-quarteira": {
    slug: "faro-airport-to-quarteira",
    originId: "faro-airport",
    destinationId: "quarteira",
    pickupValue: "faro",
    destinationValue: "Quarteira",
    price4: 35,
    price8: 45,
    distance: "23 km",
    duration: "25 min",
    routeType: "airport",
  },

  "faro-airport-to-almancil": {
    slug: "faro-airport-to-almancil",
    originId: "faro-airport",
    destinationId: "almancil",
    pickupValue: "faro",
    destinationValue: "Almancil",
    price4: 30,
    price8: 40,
    distance: "18 km",
    duration: "20 min",
    routeType: "airport",
  },

  "faro-airport-to-quinta-do-lago": {
    slug: "faro-airport-to-quinta-do-lago",
    originId: "faro-airport",
    destinationId: "quinta-do-lago",
    pickupValue: "faro",
    destinationValue: "Quinta do Lago",
    price4: 30,
    price8: 40,
    distance: "18 km",
    duration: "20 min",
    routeType: "airport",
  },

  "faro-airport-to-vale-do-lobo": {
    slug: "faro-airport-to-vale-do-lobo",
    originId: "faro-airport",
    destinationId: "vale-do-lobo",
    pickupValue: "faro",
    destinationValue: "Vale do Lobo",
    price4: 35,
    price8: 45,
    distance: "21 km",
    duration: "22 min",
    routeType: "airport",
  },

  "faro-airport-to-loule": {
    slug: "faro-airport-to-loule",
    originId: "faro-airport",
    destinationId: "loule",
    pickupValue: "faro",
    destinationValue: "Loulé",
    price4: 35,
    price8: 45,
    distance: "19 km",
    duration: "22 min",
    routeType: "airport",
  },

  "faro-airport-to-faro": {
    slug: "faro-airport-to-faro",
    originId: "faro-airport",
    destinationId: "faro",
    pickupValue: "faro",
    destinationValue: "Faro (City)",
    price4: 20,
    price8: 30,
    distance: "7 km",
    duration: "12 min",
    routeType: "airport",
  },

  "faro-airport-to-olhao": {
    slug: "faro-airport-to-olhao",
    originId: "faro-airport",
    destinationId: "olhao",
    pickupValue: "faro",
    destinationValue: "Olhão",
    price4: 30,
    price8: 40,
    distance: "15 km",
    duration: "18 min",
    routeType: "airport",
  },

  "faro-airport-to-tavira": {
    slug: "faro-airport-to-tavira",
    originId: "faro-airport",
    destinationId: "tavira",
    pickupValue: "faro",
    destinationValue: "Tavira",
    price4: 45,
    price8: 55,
    distance: "40 km",
    duration: "35 min",
    routeType: "airport",
  },

  "faro-airport-to-cabanas-de-tavira": {
    slug: "faro-airport-to-cabanas-de-tavira",
    originId: "faro-airport",
    destinationId: "cabanas-de-tavira",
    pickupValue: "faro",
    destinationValue: "Cabanas de Tavira",
    price4: 50,
    price8: 60,
    distance: "47 km",
    duration: "40 min",
    routeType: "airport",
  },

  "faro-airport-to-monte-gordo": {
    slug: "faro-airport-to-monte-gordo",
    originId: "faro-airport",
    destinationId: "monte-gordo",
    pickupValue: "faro",
    destinationValue: "Monte Gordo",
    price4: 75,
    price8: 95,
    distance: "60 km",
    duration: "45 min",
    routeType: "airport",
  },

  "faro-airport-to-vila-real-de-santo-antonio": {
    slug: "faro-airport-to-vila-real-de-santo-antonio",
    originId: "faro-airport",
    destinationId: "vila-real-de-santo-antonio",
    pickupValue: "faro",
    destinationValue: "Vila Real de Sto António",
    price4: 80,
    price8: 100,
    distance: "65 km",
    duration: "50 min",
    routeType: "airport",
  },

  "faro-airport-to-armacao-de-pera": {
    slug: "faro-airport-to-armacao-de-pera",
    originId: "faro-airport",
    destinationId: "armacao-de-pera",
    pickupValue: "faro",
    destinationValue: "Armação de Pêra",
    price4: 50,
    price8: 60,
    distance: "50 km",
    duration: "40 min",
    routeType: "airport",
  },

  "faro-airport-to-porches": {
    slug: "faro-airport-to-porches",
    originId: "faro-airport",
    destinationId: "porches",
    pickupValue: "faro",
    destinationValue: "Porches",
    price4: 55,
    price8: 70,
    distance: "55 km",
    duration: "45 min",
    routeType: "airport",
  },

  "faro-airport-to-lagoa": {
    slug: "faro-airport-to-lagoa",
    originId: "faro-airport",
    destinationId: "lagoa",
    pickupValue: "faro",
    destinationValue: "Lagoa",
    price4: 60,
    price8: 75,
    distance: "60 km",
    duration: "45 min",
    routeType: "airport",
  },

  "faro-airport-to-carvoeiro": {
    slug: "faro-airport-to-carvoeiro",
    originId: "faro-airport",
    destinationId: "carvoeiro",
    pickupValue: "faro",
    destinationValue: "Carvoeiro",
    price4: 65,
    price8: 80,
    distance: "65 km",
    duration: "50 min",
    routeType: "airport",
  },

  "faro-airport-to-ferragudo": {
    slug: "faro-airport-to-ferragudo",
    originId: "faro-airport",
    destinationId: "ferragudo",
    pickupValue: "faro",
    destinationValue: "Ferragudo",
    price4: 70,
    price8: 85,
    distance: "68 km",
    duration: "50 min",
    routeType: "airport",
  },

  "faro-airport-to-portimao": {
    slug: "faro-airport-to-portimao",
    originId: "faro-airport",
    destinationId: "portimao",
    pickupValue: "faro",
    destinationValue: "Portimão",
    price4: 70,
    price8: 85,
    distance: "70 km",
    duration: "50 min",
    routeType: "airport",
  },

  "faro-airport-to-praia-da-rocha": {
    slug: "faro-airport-to-praia-da-rocha",
    originId: "faro-airport",
    destinationId: "praia-da-rocha",
    pickupValue: "faro",
    destinationValue: "Praia da Rocha (Portimão)",
    price4: 75,
    price8: 90,
    distance: "72 km",
    duration: "55 min",
    routeType: "airport",
  },

  "faro-airport-to-alvor": {
    slug: "faro-airport-to-alvor",
    originId: "faro-airport",
    destinationId: "alvor",
    pickupValue: "faro",
    destinationValue: "Alvor",
    price4: 80,
    price8: 95,
    distance: "75 km",
    duration: "55 min",
    routeType: "airport",
  },

  "faro-airport-to-lagos": {
    slug: "faro-airport-to-lagos",
    originId: "faro-airport",
    destinationId: "lagos",
    pickupValue: "faro",
    destinationValue: "Lagos",
    price4: 90,
    price8: 110,
    distance: "90 km",
    duration: "1h",
    routeType: "airport",
  },

  "faro-airport-to-praia-da-luz": {
    slug: "faro-airport-to-praia-da-luz",
    originId: "faro-airport",
    destinationId: "praia-da-luz",
    pickupValue: "faro",
    destinationValue: "Praia da Luz (Lagos)",
    price4: 95,
    price8: 115,
    distance: "95 km",
    duration: "1h 5min",
    routeType: "airport",
  },

  "faro-airport-to-burgau": {
    slug: "faro-airport-to-burgau",
    originId: "faro-airport",
    destinationId: "burgau",
    pickupValue: "faro",
    destinationValue: "Burgau",
    price4: 100,
    price8: 120,
    distance: "100 km",
    duration: "1h 10min",
    routeType: "airport",
  },

  "faro-airport-to-salema": {
    slug: "faro-airport-to-salema",
    originId: "faro-airport",
    destinationId: "salema",
    pickupValue: "faro",
    destinationValue: "Salema",
    price4: 105,
    price8: 125,
    distance: "105 km",
    duration: "1h 15min",
    routeType: "airport",
  },

  "faro-airport-to-sagres": {
    slug: "faro-airport-to-sagres",
    originId: "faro-airport",
    destinationId: "sagres",
    pickupValue: "faro",
    destinationValue: "Sagres",
    price4: 115,
    price8: 135,
    distance: "115 km",
    duration: "1h 25min",
    routeType: "airport",
  },

  "faro-airport-to-seville": {
    slug: "faro-airport-to-seville",
    originId: "faro-airport",
    destinationId: "seville",
    pickupValue: "faro",
    destinationValue: "Seville (Spain)",
    price4: 270,
    price8: 338,
    distance: "216 km",
    duration: "2h 12m",
    routeType: "airport",
  },

  "faro-airport-to-lisbon": {
    slug: "faro-airport-to-lisbon",
    originId: "faro-airport",
    destinationId: "lisbon",
    pickupValue: "faro",
    destinationValue: "Lisboa",
    price4: 345,
    price8: 432,
    distance: "276 km",
    duration: "2h 30m",
    routeType: "airport",
  },

    // ============================================
  // ALGARVE → ALGARVE PRIVATE TRANSFERS
  // ============================================

  "albufeira-to-lagos": {
    slug: "albufeira-to-lagos",
    originId: "albufeira",
    destinationId: "lagos",
    pickupValue: "Albufeira",
    destinationValue: "Lagos",
    price4: 69,
    price8: 87,
    distance: "60 km",
    duration: "45 min",
    routeType: "private",
  },

  "albufeira-to-vilamoura": {
    slug: "albufeira-to-vilamoura",
    originId: "albufeira",
    destinationId: "vilamoura",
    pickupValue: "Albufeira",
    destinationValue: "Vilamoura",
    price4: 19,
    price8: 24,
    distance: "16 km",
    duration: "23 min",
    routeType: "private",
  },

  "albufeira-to-portimao": {
    slug: "albufeira-to-portimao",
    originId: "albufeira",
    destinationId: "portimao",
    pickupValue: "Albufeira",
    destinationValue: "Portimão",
    price4: 42,
    price8: 53,
    distance: "36 km",
    duration: "33 min",
    routeType: "private",
  },

  "albufeira-to-praia-da-rocha": {
    slug: "albufeira-to-praia-da-rocha",
    originId: "albufeira",
    destinationId: "praia-da-rocha",
    pickupValue: "Albufeira",
    destinationValue: "Praia da Rocha (Portimão)",
    price4: 45,
    price8: 57,
    distance: "39 km",
    duration: "37 min",
    routeType: "private",
  },

  "albufeira-to-carvoeiro": {
    slug: "albufeira-to-carvoeiro",
    originId: "albufeira",
    destinationId: "carvoeiro",
    pickupValue: "Albufeira",
    destinationValue: "Carvoeiro",
    price4: 38,
    price8: 48,
    distance: "33 km",
    duration: "35 min",
    routeType: "private",
  },

  "albufeira-to-alvor": {
    slug: "albufeira-to-alvor",
    originId: "albufeira",
    destinationId: "alvor",
    pickupValue: "Albufeira",
    destinationValue: "Alvor",
    price4: 50,
    price8: 63,
    distance: "43 km",
    duration: "40 min",
    routeType: "private",
  },

  "albufeira-to-tavira": {
    slug: "albufeira-to-tavira",
    originId: "albufeira",
    destinationId: "tavira",
    pickupValue: "Albufeira",
    destinationValue: "Tavira",
    price4: 81,
    price8: 102,
    distance: "70 km",
    duration: "50 min",
    routeType: "private",
  },

  "albufeira-to-quinta-do-lago": {
    slug: "albufeira-to-quinta-do-lago",
    originId: "albufeira",
    destinationId: "quinta-do-lago",
    pickupValue: "Albufeira",
    destinationValue: "Quinta do Lago",
    price4: 49,
    price8: 62,
    distance: "42 km",
    duration: "39 min",
    routeType: "private",
  },

  "albufeira-to-vale-do-lobo": {
    slug: "albufeira-to-vale-do-lobo",
    originId: "albufeira",
    destinationId: "vale-do-lobo",
    pickupValue: "Albufeira",
    destinationValue: "Vale do Lobo",
    price4: 46,
    price8: 58,
    distance: "40 km",
    duration: "37 min",
    routeType: "private",
  },

  "lagos-to-portimao": {
    slug: "lagos-to-portimao",
    originId: "lagos",
    destinationId: "portimao",
    pickupValue: "Lagos",
    destinationValue: "Portimão",
    price4: 31,
    price8: 39,
    distance: "27 km",
    duration: "25 min",
    routeType: "private",
  },

  "lagos-to-praia-da-rocha": {
    slug: "lagos-to-praia-da-rocha",
    originId: "lagos",
    destinationId: "praia-da-rocha",
    pickupValue: "Lagos",
    destinationValue: "Praia da Rocha (Portimão)",
    price4: 34,
    price8: 43,
    distance: "29 km",
    duration: "29 min",
    routeType: "private",
  },

  "lagos-to-alvor": {
    slug: "lagos-to-alvor",
    originId: "lagos",
    destinationId: "alvor",
    pickupValue: "Lagos",
    destinationValue: "Alvor",
    price4: 24,
    price8: 30,
    distance: "21 km",
    duration: "22 min",
    routeType: "private",
  },

  "lagos-to-carvoeiro": {
    slug: "lagos-to-carvoeiro",
    originId: "lagos",
    destinationId: "carvoeiro",
    pickupValue: "Lagos",
    destinationValue: "Carvoeiro",
    price4: 43,
    price8: 54,
    distance: "37 km",
    duration: "37 min",
    routeType: "private",
  },

  "lagos-to-sagres": {
    slug: "lagos-to-sagres",
    originId: "lagos",
    destinationId: "sagres",
    pickupValue: "Lagos",
    destinationValue: "Sagres",
    price4: 39,
    price8: 49,
    distance: "34 km",
    duration: "35 min",
    routeType: "private",
  },

  "lagos-to-vilamoura": {
    slug: "lagos-to-vilamoura",
    originId: "lagos",
    destinationId: "vilamoura",
    pickupValue: "Lagos",
    destinationValue: "Vilamoura",
    price4: 88,
    price8: 110,
    distance: "76 km",
    duration: "58 min",
    routeType: "private",
  },

  "portimao-to-carvoeiro": {
    slug: "portimao-to-carvoeiro",
    originId: "portimao",
    destinationId: "carvoeiro",
    pickupValue: "Portimão",
    destinationValue: "Carvoeiro",
    price4: 15,
    price8: 19,
    distance: "13 km",
    duration: "18 min",
    routeType: "private",
  },

  "portimao-to-lagos": {
    slug: "portimao-to-lagos",
    originId: "portimao",
    destinationId: "lagos",
    pickupValue: "Portimão",
    destinationValue: "Lagos",
    price4: 31,
    price8: 39,
    distance: "27 km",
    duration: "25 min",
    routeType: "private",
  },

  "portimao-to-sagres": {
    slug: "portimao-to-sagres",
    originId: "portimao",
    destinationId: "sagres",
    pickupValue: "Portimão",
    destinationValue: "Sagres",
    price4: 66,
    price8: 83,
    distance: "57 km",
    duration: "51 min",
    routeType: "private",
  },

  "vilamoura-to-lagos": {
    slug: "vilamoura-to-lagos",
    originId: "vilamoura",
    destinationId: "lagos",
    pickupValue: "Vilamoura",
    destinationValue: "Lagos",
    price4: 88,
    price8: 110,
    distance: "76 km",
    duration: "58 min",
    routeType: "private",
  },

  "vilamoura-to-tavira": {
    slug: "vilamoura-to-tavira",
    originId: "vilamoura",
    destinationId: "tavira",
    pickupValue: "Vilamoura",
    destinationValue: "Tavira",
    price4: 66,
    price8: 83,
    distance: "57 km",
    duration: "45 min",
    routeType: "private",
  },

  "vilamoura-to-quinta-do-lago": {
    slug: "vilamoura-to-quinta-do-lago",
    originId: "vilamoura",
    destinationId: "quinta-do-lago",
    pickupValue: "Vilamoura",
    destinationValue: "Quinta do Lago",
    price4: 14,
    price8: 18,
    distance: "12 km",
    duration: "18 min",
    routeType: "private",
  },

  "vilamoura-to-vale-do-lobo": {
    slug: "vilamoura-to-vale-do-lobo",
    originId: "vilamoura",
    destinationId: "vale-do-lobo",
    pickupValue: "Vilamoura",
    destinationValue: "Vale do Lobo",
    price4: 12,
    price8: 15,
    distance: "10 km",
    duration: "16 min",
    routeType: "private",
  },

  "quinta-do-lago-to-vale-do-lobo": {
    slug: "quinta-do-lago-to-vale-do-lobo",
    originId: "quinta-do-lago",
    destinationId: "vale-do-lobo",
    pickupValue: "Quinta do Lago",
    destinationValue: "Vale do Lobo",
    price4: 9,
    price8: 12,
    distance: "7 km",
    duration: "13 min",
    routeType: "private",
  },

  "tavira-to-monte-gordo": {
    slug: "tavira-to-monte-gordo",
    originId: "tavira",
    destinationId: "monte-gordo",
    pickupValue: "Tavira",
    destinationValue: "Monte Gordo",
    price4: 25,
    price8: 32,
    distance: "22 km",
    duration: "22 min",
    routeType: "private",
  },

  "tavira-to-vila-real-de-santo-antonio": {
    slug: "tavira-to-vila-real-de-santo-antonio",
    originId: "tavira",
    destinationId: "vila-real-de-santo-antonio",
    pickupValue: "Tavira",
    destinationValue: "Vila Real de Sto António",
    price4: 29,
    price8: 37,
    distance: "25 km",
    duration: "25 min",
    routeType: "private",
  },
    // ============================================
  // LONG-DISTANCE PRIVATE TRANSFERS
  // ============================================

  "albufeira-to-lisbon": {
    slug: "albufeira-to-lisbon",
    originId: "albufeira",
    destinationId: "lisbon",
    pickupValue: "Albufeira",
    destinationValue: "Lisboa",
    price4: 320,
    price8: 400,
    distance: "256 km",
    duration: "2h 27m",
    routeType: "long-distance",
  },

  "albufeira-to-seville": {
    slug: "albufeira-to-seville",
    originId: "albufeira",
    destinationId: "seville",
    pickupValue: "Albufeira",
    destinationValue: "Seville (Spain)",
    price4: 289,
    price8: 362,
    distance: "231 km",
    duration: "2h 25m",
    routeType: "long-distance",
  },

  "lagos-to-lisbon": {
    slug: "lagos-to-lisbon",
    originId: "lagos",
    destinationId: "lisbon",
    pickupValue: "Lagos",
    destinationValue: "Lisboa",
    price4: 378,
    price8: 473,
    distance: "302 km",
    duration: "2h 52m",
    routeType: "long-distance",
  },

  "lagos-to-seville": {
    slug: "lagos-to-seville",
    originId: "lagos",
    destinationId: "seville",
    pickupValue: "Lagos",
    destinationValue: "Seville (Spain)",
    price4: 345,
    price8: 432,
    distance: "276 km",
    duration: "2h 51m",
    routeType: "long-distance",
  },

  "vilamoura-to-lisbon": {
    slug: "vilamoura-to-lisbon",
    originId: "vilamoura",
    destinationId: "lisbon",
    pickupValue: "Vilamoura",
    destinationValue: "Lisboa",
    price4: 329,
    price8: 412,
    distance: "263 km",
    duration: "2h 32m",
    routeType: "long-distance",
  },

  "vilamoura-to-seville": {
    slug: "vilamoura-to-seville",
    originId: "vilamoura",
    destinationId: "seville",
    pickupValue: "Vilamoura",
    destinationValue: "Seville (Spain)",
    price4: 268,
    price8: 335,
    distance: "214 km",
    duration: "2h 18m",
    routeType: "long-distance",
  },

  "portimao-to-lisbon": {
    slug: "portimao-to-lisbon",
    originId: "portimao",
    destinationId: "lisbon",
    pickupValue: "Portimão",
    destinationValue: "Lisboa",
    price4: 353,
    price8: 442,
    distance: "282 km",
    duration: "2h 42m",
    routeType: "long-distance",
  },

  "portimao-to-seville": {
    slug: "portimao-to-seville",
    originId: "portimao",
    destinationId: "seville",
    pickupValue: "Portimão",
    destinationValue: "Seville (Spain)",
    price4: 320,
    price8: 400,
    distance: "256 km",
    duration: "2h 41m",
    routeType: "long-distance",
  },

  "tavira-to-lisbon": {
    slug: "tavira-to-lisbon",
    originId: "tavira",
    destinationId: "lisbon",
    pickupValue: "Tavira",
    destinationValue: "Lisboa",
    price4: 379,
    price8: 474,
    distance: "303 km",
    duration: "2h 50m",
    routeType: "long-distance",
  },

  "tavira-to-seville": {
    slug: "tavira-to-seville",
    originId: "tavira",
    destinationId: "seville",
    pickupValue: "Tavira",
    destinationValue: "Seville (Spain)",
    price4: 218,
    price8: 273,
    distance: "174 km",
    duration: "1h 51m",
    routeType: "long-distance",
  },

  "quinta-do-lago-to-lisbon": {
    slug: "quinta-do-lago-to-lisbon",
    originId: "quinta-do-lago",
    destinationId: "lisbon",
    pickupValue: "Quinta do Lago",
    destinationValue: "Lisboa",
    price4: 343,
    price8: 429,
    distance: "274 km",
    duration: "2h 41m",
    routeType: "long-distance",
  },

  "quinta-do-lago-to-seville": {
    slug: "quinta-do-lago-to-seville",
    originId: "quinta-do-lago",
    destinationId: "seville",
    pickupValue: "Quinta do Lago",
    destinationValue: "Seville (Spain)",
    price4: 263,
    price8: 329,
    distance: "210 km",
    duration: "2h 18m",
    routeType: "long-distance",
  },

  "vale-do-lobo-to-lisbon": {
    slug: "vale-do-lobo-to-lisbon",
    originId: "vale-do-lobo",
    destinationId: "lisbon",
    pickupValue: "Vale do Lobo",
    destinationValue: "Lisboa",
    price4: 340,
    price8: 425,
    distance: "272 km",
    duration: "2h 38m",
    routeType: "long-distance",
  },

  "vale-do-lobo-to-seville": {
    slug: "vale-do-lobo-to-seville",
    originId: "vale-do-lobo",
    destinationId: "seville",
    pickupValue: "Vale do Lobo",
    destinationValue: "Seville (Spain)",
    price4: 267,
    price8: 334,
    distance: "213 km",
    duration: "2h 17m",
    routeType: "long-distance",
  },

  "monte-gordo-to-seville": {
    slug: "monte-gordo-to-seville",
    originId: "monte-gordo",
    destinationId: "seville",
    pickupValue: "Monte Gordo",
    destinationValue: "Seville (Spain)",
    price4: 193,
    price8: 242,
    distance: "154 km",
    duration: "1h 41m",
    routeType: "long-distance",
  },
};